export interface GetAgreementListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAgreementListPagingAndFilterResponseData
}

export interface GetAgreementListPagingAndFilterResponseData {
    items: GetAgreementListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetAgreementListPagingAndFilterResponseItem {
    agreementId: string
    companyId: string
    refNo: string
    name: string
    selectedCompanyId: string
    productKindId: string
    startDate: string
    endDate: string
    isCustomActive: boolean
    isClosedArea: boolean
    isIncome: boolean
    isOpenArea: boolean
    isOutcome: boolean
    isHeatControllerRoom: boolean
    heatControlDetailId?: string
    productKindName: string
    heatControlDetailName?: string
    selectedCompanyName: string
    agreementDetails: GetAgreementListPagingAndFilterResponseAgreementDetail[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetAgreementListPagingAndFilterResponseAgreementDetail {
    agreementDetailId: string
    agreementId: string
    serviceId: string
    potTypeId: string
    multiplier1Id: string
    multiplier2Id: string
    unitPrice: number
    currencyTypeId: string
    minPrice: number
    serviceName: string
    potTypeName: string
    multiplier1Name: string
    multiplier2Name: string
    currencyTypeName: string
}

export const initialGetAgreementListPagingAndFilterResponseData: GetAgreementListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}